import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class StripeTaxAmount extends BaseModel {
  public amount: number;
  public taxRate: string;

  constructor(model: Partial<StripeTaxAmount> = {}) {
    super();

    this.amount = model.amount!;
    this.taxRate = model.taxRate!;
  }
}
